import React from "react";
import qs from "qs";

export default function useUrlParams() {
  const [searchParams, setSearchParams] = React.useState(
    window.location.search.substring(1)
  );

  // add new params to url old params
  const addParams = (newParams) => {
    let oldParams = qs.parse(searchParams);
    let mergedParams = {};

    if (Object.keys(newParams).length > 0) {
      Object.keys(newParams).forEach((key) => {
        if (!oldParams[key]) {
          mergedParams[key] = newParams[key];
        }
      });
    }

    if (Object.keys(oldParams).length > 0) {
      Object.keys(oldParams).forEach((key) => {
        if (newParams[key]) {
          if (typeof oldParams[key] === "object") {

            Object.entries(oldParams[key]).forEach((item) => {
              let toMergeWith = Object.entries(newParams[key]);
              if (item[0] === toMergeWith[0][0]) {
                mergedParams[key] = {
                  ...mergedParams[key],
                  [item[0]]: [
                    ...item[1].map((r) => String(r)),
                    ...toMergeWith[0][1].map((r) => String(r)),
                  ],
                };
              } else {
                mergedParams[key] = {
                  ...oldParams[key],
                  ...mergedParams[key],
                  [toMergeWith[0][0]]: [
                    ...toMergeWith[0][1].map((r) => String(r)),
                  ],
                };
              }

              // remove duplicates in mergedParams
              Object.keys(mergedParams[key]).forEach((item) => {
                mergedParams[key][item] = [...new Set(mergedParams[key][item])];
              });
            });
          } else {
            mergedParams[key] = newParams[key];
          }
        } else {
          mergedParams[key] = oldParams[key];
        }
      });
    } else {
      mergedParams = newParams;
    }
    setSearchParams(mergedParams);
    let newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?${qs.stringify(mergedParams, {
        encodeValuesOnly: true,
      })}`;
    window.history.pushState({ path: newurl }, "", newurl);
  };

  // remove params subobjects from url
  const removeParams = (paramsToRemove) => {
    let oldParams = qs.parse(searchParams);
    let newParams = {};
    Object.keys(oldParams).forEach((key) => {
      if (paramsToRemove[key]) {
        if (typeof oldParams[key] === "object") {
          Object.entries(oldParams[key]).forEach((item) => {
            let toMergeWith = Object.entries(paramsToRemove[key]);
            if (item[0] === toMergeWith[0][0]) {
              let newArr = item[1]
                .map((r) => String(r))
                .filter(
                  (x) =>
                    toMergeWith[0][1].map((r) => String(r)).indexOf(x) === -1
                );
              newParams[key] = {
                ...newParams[key],
                [item[0]]: newArr,
              };

              // remove empty subobjects from newParams
              if (newArr.length === 0) {
                delete oldParams[key][item[0]];
              }
            } else {
              newParams[key] = {
                ...oldParams[key],
              };
            }
          });
        } else {
          newParams[key] = paramsToRemove[key];
        }
      } else {
        newParams[key] = oldParams[key];
      }
    });
    setSearchParams(newParams);
    let newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      `?${qs.stringify(newParams, {
        encodeValuesOnly: true,
      })}`;
    window.history.pushState({ path: newurl }, "", newurl);
  };

  return {
    params: searchParams,
    addParams,
    removeParams,
  };
}
